import { memo } from "react";
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import Clipboard from "ui/molecules/Clipboard";
import Label from "./Label";
import type { PaymentMethodCurrenciesProps } from "./types";

const PaymentMethodCurrencies = ({ slotProps, forCurrencies }: PaymentMethodCurrenciesProps) => (
    <Label
        title='Currencies'
        {...slotProps?.label}
    >
        <Tooltip
            title={forCurrencies}
            {...slotProps?.tooltip}
        >
            <Box
                sx={{
                    maxWidth: '100px',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis'
                }}
            >
                <Clipboard
                    sx={{
                        fontWeight: 700
                    }}
                >
                    {forCurrencies}
                </Clipboard>
            </Box>
        </Tooltip>
    </Label>
);

export default memo(PaymentMethodCurrencies);